import { useState } from 'react';
import PageHeader from '../components/PageHeader';
import { useBusiness } from '../context/BusinessContext';

const API = import.meta.env.VITE_API_BASE_URL || '/api';
const ENTITIES = [
  { key: 'customers', label: 'Customers' },
  { key: 'items', label: 'Items / services' },
  { key: 'invoices', label: 'Invoices' },
  { key: 'expenses', label: 'Expenses' },
];

export default function Export() {
  const { activeId, activeBusiness } = useBusiness();
  const [entity, setEntity] = useState('customers');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function download() {
    setBusy(true); setError(null);
    try {
      const res = await fetch(`${API}/export/${entity}?business_id=${activeId}`, { credentials: 'include' });
      if (!res.ok) {
        const j = await res.json().catch(() => ({}));
        throw new Error(j.error || `Export failed (${res.status})`);
      }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `${entity}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch (e) { setError(e.message || 'Export failed.'); }
    finally { setBusy(false); }
  }

  return (
    <>
      <PageHeader title="Export" />
      <section className="panel" style={{ padding: 20 }}>
        <h3 style={{ marginTop: 0 }}>Export to CSV</h3>
        <p className="hint">
          Download a CSV from <strong>{activeBusiness?.name || 'the selected business'}</strong>. Opens in Excel, Google Sheets, or Zoho Books.
        </p>
        <div className="field" style={{ maxWidth: 320 }}>
          <label>What to export</label>
          <select value={entity} onChange={(e) => setEntity(e.target.value)}>
            {ENTITIES.map((en) => <option key={en.key} value={en.key}>{en.label}</option>)}
          </select>
        </div>
        {error && <div className="form-error" style={{ marginTop: 12 }}>{error}</div>}
        <button className="btn btn--primary" style={{ marginTop: 12 }} disabled={busy} onClick={download}>
          {busy ? 'Preparing…' : 'Download CSV'}
        </button>
      </section>
    </>
  );
}
